import Vue from "vue";

import SecondChanceLanding from "./SecondChanceLanding.vue";

export function load() {
    const selector = "second-chance-promotions";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SecondChanceLanding, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
